import { findKey, keys } from "lodash";

import data_level_pb from "@skydio/pbtypes/pbtypes/tools/cloud_api/data_level_pb";
import enums_pb from "@skydio/pbtypes/pbtypes/tools/cloud_api/enums_pb";
import org_permission_pb from "@skydio/pbtypes/pbtypes/tools/cloud_api/org_permission_pb";
import org_tier_pb from "@skydio/pbtypes/pbtypes/tools/cloud_api/org_tier_pb";
import type { ValueType } from "@skydio/core";

export const orgPermissionEnum = org_permission_pb.OrgPermission.PermEnum;
export const featureSwitchEnum = enums_pb.FeatureSwitch.FeatureSwitchEnum;
export const orgTierEnum = org_tier_pb.OrgTier.OrgTierEnum;
export const dataLevelEnum = data_level_pb.DataLevel.LevelEnum;

export const orgPermissionKeys = keys(orgPermissionEnum);

export const getOrgPermissionKey = (
  permission: ValueType<org_permission_pb.OrgPermission.PermEnumMap>
) => findKey(org_permission_pb.OrgPermission.PermEnum, o => o === permission);

export const getFeatureSwitchKey = (
  switchValue: ValueType<enums_pb.FeatureSwitch.FeatureSwitchEnumMap>
) => findKey(enums_pb.FeatureSwitch.FeatureSwitchEnum, o => o === switchValue);
